module.exports = __webpack_public_path__ + "static/img/image5.e6645be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image5.png
// module id = xRE8
// module chunks = 0